(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["msrp-mg-header"] && !Shopify.designMode) return;
  try {
    function initializeMgCartIcons() {
    document.querySelectorAll('cart-icon.msrp-mg-header__cart').forEach(function(icon) {
      if (icon.dataset.mgInitialized) return;
      icon.dataset.mgInitialized = 'true';
      const counter = icon.querySelector('[data-ref="cart-count"]');
      if (!counter) return;
      function updateCounter() {
        const count = Number.parseInt(counter.textContent, 10) || 0;
        counter.hidden = count === 0;
        icon.setAttribute('aria-label', 'Panier : ' + count + ' articles');
      }
      updateCounter();
      new MutationObserver(updateCounter).observe(counter, { childList: true, characterData: true, subtree: true });
      icon.addEventListener('keydown', function(event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          icon.click();
        }
      });
    });
  }
  initializeMgCartIcons();
  document.addEventListener('shopify:section:load', initializeMgCartIcons);
  } catch(e) { console.error(e); }
})();

})();
